module.exports = __webpack_public_path__ + "static/media/image-404.beec4cc8.svg";